module.exports = __webpack_public_path__ + "media/images/checkmark-blue-267bdd615328036999351027fa230ade.svg";